// Zahlen und Daten sind Aussagen (lilasprojekte .impeccable.md): 14.10.2026, Europe/Berlin.

const DATUM = new Intl.DateTimeFormat("de-DE", {
  day: "2-digit", month: "2-digit", year: "numeric", timeZone: "Europe/Berlin",
});

/** "2026-10-14" oder ein Zeitpunkt → "14.10.2026". Ein reines Datum wird NICHT über
 *  `new Date()` geschickt: das läse es als UTC-Mitternacht und zeigte westlich von
 *  Greenwich den Vortag. */
export function datum(w: string | null | undefined): string {
  if (!w) return "";
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(w);
  if (m) return `${m[3]}.${m[2]}.${m[1]}`;
  return DATUM.format(new Date(w));
}

const TEILE = new Intl.DateTimeFormat("de-DE", {
  year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit",
  hourCycle: "h23", timeZone: "Europe/Berlin",
});

/** Zeitpunkt → "2026-10-30T10:00" in Berliner Ortszeit, fuer `<input type="datetime-local">`.
 *  Nicht `slice(0, 16)` des ISO-Texts: der steht in UTC, und das Feld zeigte 9:00 statt 10:00.
 *  Zurueck geht der Wert zonenlos; das Backend liest ihn als Europe/Berlin. */
export function ortszeitEingabe(w: string | null | undefined): string {
  if (!w) return "";
  const t = Object.fromEntries(TEILE.formatToParts(new Date(w)).map((x) => [x.type, x.value]));
  return `${t.year}-${t.month}-${t.day}T${t.hour}:${t.minute}`;
}

/** E12 — welcher Status von welchem aus erreichbar ist. DIESELBE Tabelle steht im Backend
 *  (MANGEL_UEBERGAENGE) und gewinnt dort; hier entscheidet sie nur, welche Knoepfe es gibt.
 *  Ruecksprung erledigt → angezeigt und entfallen → offen: ein Fehltipp muss heilbar sein. */
export const MANGEL_UEBERGAENGE: Record<string, string[]> = {
  offen: ["angezeigt", "erledigt", "entfallen"],
  angezeigt: ["beseitigt_gemeldet", "erledigt", "strittig", "entfallen", "offen"],
  beseitigt_gemeldet: ["erledigt", "angezeigt"],
  strittig: ["angezeigt", "erledigt", "entfallen"],
  erledigt: ["angezeigt"],
  entfallen: ["offen"],
};

export function heute(): string {
  const t = new Date();
  const p = (n: number) => String(n).padStart(2, "0");
  return `${t.getFullYear()}-${p(t.getMonth() + 1)}-${p(t.getDate())}`;
}

export const BESPRECHUNG_ART: Record<string, string> = {
  baubesprechung: "Baubesprechung",
  jour_fixe: "Jour fixe",
  planungsbesprechung: "Planungsbesprechung",
  sonstige: "Besprechung",
};

export const BEGEHUNG_ART: Record<string, string> = {
  abnahme: "Abnahme",
  teilabnahme: "Teilabnahme",
  zustandsfeststellung: "Zustandsfeststellung",
  zustand_abnahmeverweigerung: "Zustandsfeststellung nach Abnahmeverweigerung",
  maengelbegehung: "Mängelbegehung",
  gewaehrleistungsbegehung: "Gewährleistungsbegehung",
};

export const BEGEHUNG_GRUNDLAGE: Record<string, string> = {
  abnahme: "§ 12 Abs. 4 VOB/B",
  teilabnahme: "§ 12 Abs. 2 VOB/B",
  zustandsfeststellung: "§ 4 Abs. 10 VOB/B",
  zustand_abnahmeverweigerung: "§ 650g BGB",
  maengelbegehung: "",
  gewaehrleistungsbegehung: "§ 13 VOB/B",
};

export const ERGEBNIS: Record<string, string> = {
  offen: "offen",
  abgenommen: "abgenommen",
  abgenommen_vorbehalt: "abgenommen unter Vorbehalt",
  verweigert: "Abnahme verweigert",
  festgestellt: "festgestellt",
};

export const MANGEL_STATUS: Record<string, string> = {
  offen: "offen",
  angezeigt: "angezeigt",
  beseitigt_gemeldet: "Beseitigung gemeldet",
  erledigt: "erledigt",
  strittig: "strittig",
  entfallen: "entfallen",
};

export const BETEILIGTER_ART: Record<string, string> = {
  bauherr: "Bauherr / AG",
  projektsteuerung: "Projektsteuerung",
  objektueberwachung: "Objektüberwachung",
  planung: "Planung",
  fachplanung: "Fachplanung",
  auftragnehmer: "Auftragnehmer",
  behoerde: "Behörde",
  sonstige: "Sonstige",
};

export const PUNKT_ART: Record<string, string> = { I: "Information", F: "Festlegung", A: "Aufgabe" };

const EURO = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" });

/** 12500.5 oder "12500.50" → "12.500,50 €"; leer bleibt leer. */
export function euro(w: number | string | null | undefined): string {
  if (w === null || w === undefined || w === "") return "";
  return EURO.format(Number(w));
}
